import React from 'react'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput.jsx";

const style = {
  inputAdornment: {
    marginRight: "18px",
    position: "relative"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  customFormControlClasses: {
    margin: "0 12px"
  }
}

class CustomInputAdornment extends React.Component {
  render () {
    const { icon: InputIcon, inputProps, classes, ...props } = this.props

    return (
      <CustomInput
        {...props}
        formControlProps={{
          fullWidth: true,
          className: classes.customFormControlClasses
        }}
        inputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              className={classes.inputAdornment}
              children={InputIcon && <InputIcon className={classes.inputAdornmentIcon} />}
            >
            </InputAdornment>
          ),
          ...inputProps
        }}
      />
    )
  }
}

CustomInputAdornment.propTypes = {
  classes: PropTypes.object.isRequired,
  inputProps: PropTypes.object,
}

export default withStyles(style)(CustomInputAdornment)


// WEBPACK FOOTER //
// ./src/components/CustomInput/CustomInputAdornment.jsx